import apiClient from "../apiInstance.js";
import { IVR_URLS } from "../../services/apiConfig.js";
import { QUEUE_ERRORS } from "../../common/constants/ivrModule/queueConstants.js";

export const getIvrQueue = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.GET_IVR_QUEUE);
        const queues = response.data.policy?.value || [];
        const responseQueues = queues.map((queue) => ({
            id: queue.id,
            queuename: queue.name,
            distributionPolicyId: queue.distributionPolicyId,
            labelId: queue.labels?.Id || "",
            etag: queue.etag,
        }));
        return responseQueues;
    } catch (error) {
        console.error(QUEUE_ERRORS.FETCH_QUEUE_ERROR, error);
        throw error;
    }
};

export const addEditIvrQueue = async (queueToSave) => {
    try {
        const response = await apiClient.post(
            IVR_URLS.ADD_IVR_QUEUE,
            queueToSave
        );
        return response.data;
    } catch (error) {
        console.error(QUEUE_ERRORS.ADD_QUEUE_ERROR, error);
        throw error;
    }
};

export const deleteIvrQueue = async (queueToDelete) => {
    try {
        const response = await apiClient.post(
            IVR_URLS.DELETE_IVR_QUEUE,
            queueToDelete
        );
        return response.data;
    } catch (error) {
        console.error(QUEUE_ERRORS.DELETE_QUEUE_ERROR, error);
        throw error;
    }
};